import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useStyles from './media-error-dialog.styles';

/**
 * Displays a user facing message coming from the asset download endpoint.
 * The message is already localised by the backend, only the chrome is translated.
 */
const MediaErrorDialog = memo((props) => {
  const { message, titleKey, onClose } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={!!message} onClose={onClose}>
      <DialogTitle className={classes.title}>{t(titleKey)}</DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.message}>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className={classes.button} variant="outlined" onClick={onClose} autoFocus>
          {t('ebook_load_error_btn')}
        </Button>
      </DialogActions>
    </Dialog>
  );
});

MediaErrorDialog.propTypes = {
  message: PropTypes.string,
  titleKey: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

MediaErrorDialog.defaultProps = {
  message: '',
  titleKey: 'playback_error_generic',
};

export default MediaErrorDialog;
